import { useContext } from "react";
import { useSelector } from "react-redux";
import { Id, Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  resources: { [uuid: Id]: Identifiable<Resource> };
  pendingUuids: Id[];
  missingUuids: Id[];
  retrieveResourcesByUuids(
    request: Boundaries["retrieveResourcesByUuids"]["request"],
  ): void;
}

function useRetrieveResourcesByUuids(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    resources: useSelector(selector.getResourcesByUuid),
    pendingUuids: useSelector(selector.getPendingResourcesUuids),
    missingUuids: useSelector(selector.getMissingResourcesUuids),
    retrieveResourcesByUuids: core.retrieveResourcesByUuids,
  };
}

export { useRetrieveResourcesByUuids };
